<template>
  <div v-if="masterConfiguration.openidLoginPath" id="openIdSignin">
    <v-btn
      color="accent"
      class="my-2 mt-4 mx-auto"
      rounded
      max-width="295px"
      min-width="295px"
      block
      @click="initiateSignIn"
    >
      {{ $t("navigation:button.LoginWithOpenid") }}
    </v-btn>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { getFederationConfiguration } from "@composables/masterdata/config";

export default defineComponent({
  name: "SignInOpenId",
  setup() {
    return {
      ...getFederationConfiguration()
    };
  },
  methods: {
    initiateSignIn() {
      if (this.masterConfiguration.openidLoginPath) {
        window.location.replace(
          process.env.VUE_APP_API_URL + this.masterConfiguration.openidLoginPath
        );
      }
    }
  }
});
</script>
